import { Button, Modal } from '@distribusion/owl-frontend-ui'
import React from 'react'

import { useCookiesAnalytics } from '@components/CookiesConsent/hooks/useCookiesAnalytics'
import TransFromHtml from '@components/TransFromHtml'
import { useTranslation } from '@lib/i18n'

import '@components/CookiesConsent/index.scss'

interface CookiesConsentProps {
  opened: boolean
  onChange: (accepted: boolean) => void
}

const CookiesConsent = ({ opened, onChange }: CookiesConsentProps) => {
  const { t } = useTranslation()
  const { sendAcceptEvent, sendRejectEvent } = useCookiesAnalytics({ opened })

  const handleAccept = () => {
    sendAcceptEvent()
    onChange(true)
  }

  const handleReject = () => {
    sendRejectEvent()
    onChange(false)
  }

  return (
    <Modal
      opened={opened}
      maxWidth="md"
      onClose={handleReject}
      title={t('cookiesConsent.title')}
      innerShadows={false}
      footer={
        <div className="cookies-consent__actions">
          <div className="row gap-3">
            <div className="cell">
              <Button dataTag="cookies-consent-reject" onClick={handleReject}>
                {t('cookiesConsent.reject')}
              </Button>
            </div>
            <div className="cell">
              <Button dataTag="cookies-consent-accept" onClick={handleAccept}>
                {t('cookiesConsent.accept')}
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <div className="cookies-consent">
        <div className="column gap-5">
          <div className="column gap-1">
            <div className="body-16">
              <TransFromHtml i18nKey="cookiesConsent.description" />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CookiesConsent
